import type { RouteConfigComponentProps } from '@lingoda/router';
import {
    Redirect,
    postCheckoutPath,
    postCheckoutWelcomePath,
    renderRoutes,
    useRouteMatcher,
} from '@lingoda/router';
import { useSelector } from '@lingoda/hooks';
import { studentPreferencesSelector } from '@lingoda/students';
import { Loader, Suspense } from '@lingoda/ui';
import { useRedirectToHomeIfShouldNotBeOnboarded } from '../../hooks';
import { ProficiencyContextProvider } from '../../components/ProficiencyContext';

const PostCheckout = ({ route }: RouteConfigComponentProps) => {
    useRedirectToHomeIfShouldNotBeOnboarded();
    const preferences = useSelector(studentPreferencesSelector);

    const isPostCheckoutMainPage = useRouteMatcher([
        { path: postCheckoutPath(), matchPrefix: false },
    ]);

    if (!preferences) {
        return <Loader />;
    }

    if (isPostCheckoutMainPage) {
        return <Redirect to={postCheckoutWelcomePath()} />;
    }

    return (
        <Suspense variant="linear">
            <ProficiencyContextProvider>{renderRoutes(route?.routes)}</ProficiencyContextProvider>
        </Suspense>
    );
};

export default PostCheckout;
